module.exports = __webpack_public_path__ + "static/img/96-3.ee19682.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/96-3.jpg
// module id = 0Szd
// module chunks = 0